<template>
  <router-view />
</template>

<script setup lang="ts">
import { useTokenRefresh } from './hooks/useTokenRefresh'

useTokenRefresh()
</script>
